import Cookies from "js-cookie";

const TokenKey = "admin";
export function getToken() {
  return Cookies.get(TokenKey);
}

export function setToken(token) {
  return Cookies.set(TokenKey, token, { expires: 999 });
}

export function removeToken() {
  return Cookies.remove(TokenKey);
}
